import { blobToFile, compress, dataURLtoBlob, imageToBase64 } from "./base64"
import OCR from "../utils/ocr"
import request from './request'
import { message } from "antd";
const API_ENV = process.env.API_ENV;

export async function basisColumnUpload(data: any) {
  const res = await request(
    `https://${API_ENV}.${API_ENV === 'lyt' ? "lieyuntong.cn" : "ailieyun.com"}/api/custom/file/upload`,
    {
      method: 'POST',
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return res
}

const COMPRESSRATIO = .6;
export const zipImg = async (file: any, ocrType: any, isBackPhotoUrl?: any) => {
  const base64: any = await imageToBase64(file.originFileObj)
  const compressImage = await compress(base64.target.result, COMPRESSRATIO)
  let blob = dataURLtoBlob(compressImage)
  const file2 = blobToFile(blob, file.name)
  const formData = new FormData();
  formData.append("file", file2);
  const res: any = await basisColumnUpload(formData);
  if (res.code === 0) {
    const data: any = { code: ocrType }
    isBackPhotoUrl ? data.backPhotoUrl = res.data : data.facePhotoUrl = res.data
    let ocr: any = await OCR(data);
    if (ocr.code === 0) {
      if (typeof ocr.data === 'string' || ocr.data === null) {
        message.error("ocr识别失败！")
        return null
      }
      return ocr
    } else {
      message.error("ocr识别失败！")
      return null
    }
  } else {
    return null
  }
}


export const zipImg10M = async (file: any) => {
  const base64: any = await imageToBase64(file.originFileObj)
  const compressImage = await compress(base64.target.result, COMPRESSRATIO)
  let blob = dataURLtoBlob(compressImage)
  const file2 = blobToFile(blob, file.name)
  const formData = new FormData();
  formData.append("file", file2);
  const res: any = await basisColumnUpload(formData);
  return res
}